import { render, staticRenderFns } from "./actions-column.vue?vue&type=template&id=477c33dc"
import script from "./actions-column.vue?vue&type=script&lang=js"
export * from "./actions-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('477c33dc')) {
      api.createRecord('477c33dc', component.options)
    } else {
      api.reload('477c33dc', component.options)
    }
    module.hot.accept("./actions-column.vue?vue&type=template&id=477c33dc", function () {
      api.rerender('477c33dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/tag/actions-column.vue"
export default component.exports